import { TextSectionElement } from "./TextSectionElement";

export default TextSectionElement;
